var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_178)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_29_178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8 0H4.2C1.8804 0 0 1.8804 0 4.2V23.8C0 26.1196 1.8804 28 4.2 28H23.8C26.1196 28 28 26.1196 28 23.8V4.2C28 1.8804 26.1196 0 23.8 0Z",
    fill: "#1DA1F2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.8984 8.31249C23.2422 8.64062 22.4766 8.85937 21.7109 8.96874C22.5312 8.47655 23.1328 7.71093 23.4609 6.78124C22.6953 7.21874 21.875 7.54687 21 7.71093C20.4049 7.1014 19.6281 6.70132 18.7863 6.57072C17.9445 6.44012 17.083 6.58606 16.3312 6.98662C15.5794 7.38719 14.9777 8.02077 14.6166 8.7923C14.2554 9.56383 14.1542 10.4317 14.3281 11.2656C11.2656 11.1016 8.3125 9.67968 6.39844 7.21874C6.13799 7.63472 5.96247 8.09815 5.88198 8.58229C5.80149 9.06644 5.81763 9.56172 5.92948 10.0396C6.04132 10.5175 6.24665 10.9685 6.53363 11.3666C6.82061 11.7648 7.18356 12.1022 7.60156 12.3594C7 12.3594 6.39844 12.25 5.85156 11.9766C5.90625 13.7812 7.16406 15.3672 8.91406 15.75C8.36719 15.9141 7.76562 15.9141 7.16406 15.8047C7.71094 17.3906 9.1875 18.4844 10.8281 18.5391C9.24219 19.8516 7.10938 20.4531 5.08594 20.125C6.77683 21.2533 8.74994 21.8855 10.7817 21.9499C12.8135 22.0143 14.8226 21.5084 16.5816 20.4894C18.3406 19.4705 19.779 17.9792 20.7339 16.1847C21.6888 14.3902 22.122 12.364 21.9844 10.3359C22.75 9.78905 23.4062 9.1328 23.8984 8.31249Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_29_178",
    x: -14,
    y: -8,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_29_178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_29_178",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.0bc1d097a69756f88f8cfc291c415a22.svg";
export { ForwardRef as ReactComponent };